import { useHistory } from 'react-router';
import { useGet } from 'redux/store/StoreCached';
import { SystemKeys } from 'consts/cachedKey';
import { useEffect } from 'react';
import { AppRoutes } from 'consts/routesPath';
import checkBalanceModel from 'models/check-balance.model';

const propTypes = {};

//* Handle case lack of billing info / min credit / ...
const PreventUserHook = () => {
  const history = useHistory();
  const hasNotEnoughCredits = checkBalanceModel.checkIsNotEnoughCredits();
  const isNotHaveBillingInfo = useGet(SystemKeys.IS_NOT_HAVE_BILLING_INFO);

  useEffect(() => {
    if (isNotHaveBillingInfo) {
      history.replace(AppRoutes.WarningUpdateBillingInfo);
    }
  }, [isNotHaveBillingInfo]);

  useEffect(() => {
    if (hasNotEnoughCredits) {
      history.replace(AppRoutes.WarningMinBalance);
    }
  }, [hasNotEnoughCredits]);

  return null;
};

PreventUserHook.propTypes = propTypes;
export default PreventUserHook;
